import { useState } from 'react';

const lineKey = (billId: string, lineId: string) => `${billId}:${lineId}`;

export const useWorklistSelection = () => {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const isSelected = (billId: string, lineId: string) => selected.has(lineKey(billId, lineId));

  const toggleLine = (billId: string, lineId: string) => {
    setSelected((current) => {
      const next = new Set(current);
      const key = lineKey(billId, lineId);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const toggleAllInBill = (billId: string, lineIds: string[]) => {
    setSelected((current) => {
      const next = new Set(current);
      const allSelected = lineIds.every((lineId) => next.has(lineKey(billId, lineId)));
      for (const lineId of lineIds) {
        const key = lineKey(billId, lineId);
        if (allSelected) next.delete(key); else next.add(key);
      }
      return next;
    });
  };

  const selectedInBill = (billId: string) => [...selected]
    .filter((key) => key.startsWith(`${billId}:`))
    .map((key) => key.slice(billId.length + 1));

  const removeMany = (billId: string, lineIds: string[]) => {
    setSelected((current) => {
      const next = new Set(current);
      for (const lineId of lineIds) next.delete(lineKey(billId, lineId));
      return next;
    });
  };

  const clear = () => setSelected(new Set());

  return { isSelected, toggleLine, toggleAllInBill, selectedInBill, removeMany, clear };
};
